import { Modal, Form, Input, Select, Button, message } from "antd";
import leadsLiftLogo from "../../../src/assests/images/leadslift-logo.png";
import { leadsLiftSocialPost } from "../../api/leadsLiftSocial";
const { TextArea } = Input;

const LeadsLiftPopup = ({ props }) => {
  const { isModalOpen, handleCancel, response, accounts } = props;

  const onFinish = async (values) => {
    let createPost = await leadsLiftSocialPost(values.account, values.response);

    if (createPost?.data?.success) {
      message.success(createPost?.message);
      handleCancel();
    } else {
      message.error(createPost?.message);
      handleCancel();
    }
  };

  return (
    <>
      <Modal
        title="Leads Lift Integration"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form 
          onFinish={onFinish} 
          layout="vertical"
          initialValues={{ response: response }}
        >
          <Form.Item
            name="account"
            label="Select Social Account"
            rules={[{ required: true, message: "Please select an account!" }]}
          >
            <Select
              showSearch
              placeholder="Select Social Account"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={accounts?.map((account) => ({
                value: account?.id,
                label: (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={account?.avatar ? account?.avatar : leadsLiftLogo}
                      alt={account?.name}
                      style={{ width: 20, height: 20, marginRight: 8 }}
                    />
                    {account?.name} <b> [ Account: {account?.platform} ] </b>
                  </div>
                ),
              }))}
            />
          </Form.Item>
          <Form.Item name="response" label="Response">
            <TextArea
              style={{ height: 200, resize: "none" }}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default LeadsLiftPopup;